"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isContentClearingKeyPress = exports.getSelectedCells = void 0;
var getSelectedCells = function (anchorCell, focusCell, rows, columns) {
    var selected = [];
    if (anchorCell === null || focusCell === null) {
        return selected;
    }
    var anchorColumn = anchorCell % columns;
    var anchorRow = Math.floor(anchorCell / columns);
    var focusColumn = focusCell % columns;
    var focusRow = Math.floor(focusCell / columns);
    var rowStart = Math.min(anchorRow, focusRow);
    var rowEnd = Math.max(anchorRow, focusRow);
    var columnStart = Math.min(anchorColumn, focusColumn);
    var columnEnd = Math.max(anchorColumn, focusColumn);
    for (var y = 0; y < rows; y++) {
        for (var x = 0; x < columns; x++) {
            if (y >= rowStart && y <= rowEnd && x >= columnStart && x <= columnEnd) {
                selected[x + y * columns] = true;
            }
            else {
                selected[x + y * columns] = false;
            }
        }
    }
    return selected;
};
exports.getSelectedCells = getSelectedCells;
var isContentClearingKeyPress = function (event) {
    var keyType = computeKeyType(event);
    return keyType === types.INPUT;
};
exports.isContentClearingKeyPress = isContentClearingKeyPress;
var codes = {
    BACKSPACE: 8,
    TAB: 9,
    ENTER: 13,
    CONTEXT_MENU: 16,
    CONTROL: 17,
    ALT: 18,
    ESC: 27,
    SPACE: 32,
    PAGEUP: 33,
    PAGEDOWN: 34,
    END: 35,
    HOME: 36,
    LEFT: 37,
    UP: 38,
    RIGHT: 39,
    DOWN: 40,
    DELETE: 46,
    META: 91,
};
var types = {
    DELETE: 1,
    INPUT: 2,
    ENTER: 3,
    NAVIGATION: 4,
    NOEFFECT: 5,
};
var isNavigationKeyCode = function (key) {
    return key >= codes.PAGEUP && key <= codes.DOWN;
};
var metaPressed = function (e) {
    return e.ctrlKey || e.altKey || e.metaKey;
};
var computeKeyType = function (e) {
    var keycode = e.which !== null ? e.which : e.keyCode;
    var type;
    if (keycode === codes.BACKSPACE || keycode === codes.DELETE) {
        type = types.DELETE;
    }
    else if (isNavigationKeyCode(keycode)) {
        type = types.NAVIGATION;
    }
    else if (keycode === codes.ENTER) {
        type = types.ENTER;
    }
    else {
        switch (keycode) {
            case codes.CONTEXT_MENU:
            case codes.CONTROL:
            case codes.ALT:
            case codes.ESC:
            case codes.META:
                type = types.NOEFFECT;
                break;
            default:
                if (e.type && e.type === "keydown" && !metaPressed(e)) {
                    type = types.INPUT;
                }
                else {
                    type = types.NOEFFECT;
                }
                break;
        }
    }
    return type;
};
